// extracted by mini-css-extract-plugin
export default {"PriceNights":"_9R4Tq","item":"IOK60","item--isActive":"GPxw5","skeleton-progress":"P9YKo"};